export default {
  namespaced: true,
  state: {
    enableViewer: false,
    cvUrl: null
  },
  mutations: {
    setEnableViewer (state, enable) {
      state.enableViewer = enable
    },
    setCVUrl (state, url) {
      state.cvUrl = url
    }
  },
  actions: {
    setCVUrl ({commit}, url) {
      commit('setCVUrl', url)
      commit('setEnableViewer', true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cv-viewer.js